/**
 * Layout constants for the game container and UI.
 * Single source of truth for canvas dimensions, border width, and derived container size.
 */

export const CANVAS_WIDTH = 900;
export const CANVAS_HEIGHT = 700;
export const BORDER_WIDTH = 3;

export const CONTAINER_WIDTH = CANVAS_WIDTH + BORDER_WIDTH * 2;
export const CONTAINER_HEIGHT = CANVAS_HEIGHT + BORDER_WIDTH * 2;

export const TOOLTIP_WIDTH = 220;
export const TOOLTIP_OFFSET = 15;
